import { useMemo } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

interface LocationProviderIds {
  locationId: string;
  providerIds?: string[];
}

export const useGetCalendarScheduleV3Data = (locationWiseProviderIds: LocationProviderIds[]) => {
  const locationIds = useMemo(() => locationWiseProviderIds.map((item) => item.locationId), [locationWiseProviderIds]);

  const officeScheduleQueries = SchedulerV3.Queries.useListSchedulesQueries(
    locationIds.map((locationId) => ({
      request: { locationId, ids: [locationId] },
      options: { enabled: !!locationId },
    }))
  );

  const providerScheduleQueries = SchedulerV3.Queries.useListSchedulesQueries(
    locationWiseProviderIds.map(({ locationId, providerIds }) => ({
      request: { locationId, ids: providerIds ?? [] },
      options: { enabled: !!providerIds?.length },
    }))
  );

  const officeSchedulesQuery = useMemo(
    () => ({
      data: officeScheduleQueries.map((query) => query.data?.schedules || []).flat(),
      isLoading: officeScheduleQueries.some((query) => query.isLoading),
      isError: officeScheduleQueries.some((query) => query.isError),
    }),
    [officeScheduleQueries]
  );

  const providerSchedulesQuery = useMemo(
    () => ({
      data: providerScheduleQueries.map((query) => query.data?.schedules || []).flat(),
      isLoading: providerScheduleQueries.some((query) => query.isLoading),
      isError: providerScheduleQueries.some((query) => query.isError),
    }),
    [providerScheduleQueries]
  );

  return {
    officeSchedulesQuery,
    providerSchedulesQuery,
  };
};
